import React, { Component } from 'react';
import { bool, func, object } from 'prop-types';
import { Box, Button } from '@mui/material';
import { connect } from 'formik';
import { I18n } from 'utils/i18n';

class ActionButtons extends Component {
  handleReset = e => {
    const { onReset, formik } = this.props;
    onReset();
    formik.handleReset(e);
  };

  render() {
    const { formik, isEdit, disabled } = this.props;
    return (
      <Box sx={{ display: 'flex', justifySelf: 'flex-end', padding: '20px 0' }}>
        <Button
          variant="outlined"
          onClick={this.handleReset}
          disabled={disabled || formik.isSubmitting}
          sx={{ color: 'primary.ultraDark', marginRight: '10px' }}
          type="reset"
          color="secondary"
        >
          {I18n.t('AppDrawer.Cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={disabled || formik.isSubmitting}
          color="primary"
          type="submit"
        >
          {formik.isSubmitting
            ? `${isEdit ? I18n.t('AppDrawer.Updating') : I18n.t('AppDrawer.Creating')}...`
            : `${isEdit ? I18n.t('AppDrawer.Update') : I18n.t('AppDrawer.Create')}`}
        </Button>
      </Box>
    );
  }
}

ActionButtons.propTypes = {
  formik: object.isRequired,
  onReset: func.isRequired,
  isEdit: bool.isRequired,
  disabled: bool,
};

ActionButtons.defaultProps = {
  disabled: false,
};

export default connect(ActionButtons);
